export enum ProductTypes {
    Plant = 'PLANT',
    Community_Plant = 'COMMUNITY_PLANT',
    Object = 'OBJECT'
}
